/* eslint-disable react/destructuring-assignment */
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { ChangeEvent } from 'react';

import { Checkbox, ICheckboxProps } from './Checkbox';

type Value = ICheckboxProps['value'];
type ICheckboxFieldProps = ICheckboxProps & FieldProps<Value, FieldRenderProps<Value>>;

export const CheckboxField = (props: ICheckboxFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      const error = typeof props.error === 'boolean' ? props.error && meta.error : meta.touched && meta.error;

      function handleChange(e: ChangeEvent<HTMLInputElement>) {
        input.onChange(e);
        if (props.onChange) {
          props.onChange(e);
        }
      }

      return <Checkbox {...props} {...input} onChange={handleChange} error={error} />;
    }}
  </Field>
);
